import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@sib/auth';
import { useLogin } from '@sib/auth';
import { Trans, useTranslation } from '@sib/i18n';
import { Hero, LoginPageLayout } from '@sib/ui';
import {
  PRIVACY_POLICY_URL,
  TERMS_OF_USE_URL,
} from '@spendbrain/config/constants';
import { paths } from '@spendbrain/config/paths';

export const Login = () => {
  const { t } = useTranslation();

  const { mutate: login, isPending } = useLogin();

  const { isAuthenticated } = useAuthStore();

  if (isAuthenticated) return <Navigate to={paths.dashboard} />;

  return (
    <LoginPageLayout
      title={t('loginPage.title', {
        appName: __APP_DISPLAY_NAME__,
      })}
      description={t('loginPage.description')}
      isLoading={isPending}
      login={login}
      backgroundImageSrc="login-background.png"
      logoIconSrc="new-logo.png"
      buttonBaseText={t('loginPage.buttonBaseText')}
      buttonLoadingText={t('loginPage.buttonLoadingText')}
      infoMessage={t('loginPage.infoMessage')}
      hero={<Hero />}
      termsInfo={
        <Trans
          i18nKey={'loginPage.termsOfUseHint'}
          t={t}
          components={{
            termsLink: (
              <a
                href={TERMS_OF_USE_URL}
                target="_blank"
                className="leading-none text-inherit underline underline-offset-1"
              />
            ),
            privacyLink: (
              <a
                href={PRIVACY_POLICY_URL}
                target="_blank"
                className="leading-none text-inherit underline underline-offset-1"
              />
            ),
          }}
        />
      }
    />
  );
};
